"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var useSearchDebounce_1 = require("../../../../hooks/useSearchDebounce");
var pages_1 = require("../../../../constants/pages");
var console_1 = require("../../../../reducers/slices/console");
var get_suppliers_thunk_1 = require("../../../../reducers/slices/client/thunks/get_suppliers_thunk");
var routes_1 = require("../../../../constants/routes");
var category_component_1 = require("./components/category_component");
var main_1 = require("../../../../reducers/slices/main");
var products_component_1 = __importDefault(require("./components/products_component"));
var product_1 = require("../../../../reducers/slices/products/product");
var SupplierTable = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _a = (0, react_redux_1.useSelector)(function (state) { return state.clientState; }), pagination = _a.pagination, suppliers = _a.suppliers;
    var _b = (0, useSearchDebounce_1.useSearchDebounce)(), search = _b[0], setSearch = _b[1];
    var _c = (0, react_1.useState)(null), filterType = _c[0], setFilterType = _c[1];
    var _d = (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Suppliers"));
    }, []);
    var getSuppliers = function (filter) {
        dispatch((0, get_suppliers_thunk_1.get_suppliers_thunk)({
            payload: __assign({}, filter),
        }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-2" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-end" }, { children: [(0, jsx_runtime_1.jsx)("div", {}), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex gap-2" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "w-32 bg-white rounded-lg p-2" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.NewDropdownControl, { label: "Filter By", options: [
                                    {
                                        label: "Category",
                                        value: "category",
                                    },
                                    {
                                        label: "Product",
                                        value: "product",
                                    },
                                ], colors: {
                                    textColor: "text-black",
                                    labelColor: "text-black",
                                    borderColor: "border-borders",
                                    iconColor: "text-primary",
                                }, renderDisplay: function (item) {
                                    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: item.label });
                                }, size: "small", value: filterType, errorText: "", onChange: function (item) {
                                    setFilterType(item);
                                    if (item.value === "category") {
                                        dispatch((0, main_1.setContentModal)({
                                            title: "Select Categories",
                                            content: ((0, jsx_runtime_1.jsx)(category_component_1.ProductCategoriesComponent, { onSave: function (selectedCategories) {
                                                    dispatch((0, product_1.setSelectedCategory)(selectedCategories));
                                                    dispatch((0, product_1.setSelectedProducts)([]));
                                                    getSuppliers({ category_ids: selectedCategories.map(function (x) { return x._id; }) });
                                                }, onSelectAllProductsChange: function () { } })),
                                        }));
                                    }
                                    if (item.value === "product") {
                                        dispatch((0, main_1.setContentModal)({
                                            title: "Select Categories",
                                            content: ((0, jsx_runtime_1.jsx)(products_component_1.default, { onSave: function (selectedProducts) {
                                                    dispatch((0, product_1.setSelectedProducts)(selectedProducts));
                                                    dispatch((0, product_1.setSelectedCategory)([]));
                                                    getSuppliers({ SKUs: selectedProducts.map(function (x) { return x.sku; }) });
                                                }, onSelectAllProductsChange: function () { } })),
                                        }));
                                    }
                                } }) })) }))] })), !true ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "grid justify-center p-4" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.CircularLoaderControl, { size: "large" }) }))) : ((0, jsx_runtime_1.jsx)(doshx_controls_web_1.TableControl, { columns: [
                    {
                        displayKey: "contact_person",
                        label: "Suppler Name",
                    },
                    {
                        displayKey: "email",
                        label: "Email",
                    },
                    {
                        displayKey: "contact_number",
                        label: "Phone Number",
                    },
                    {
                        displayKey: "name",
                        label: "Industry",
                    },
                ], onRowClicked: function (data) {
                    navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.PROCUREMENT_ROUTE).concat(routes_1.SUPPLIERS_DETAILS_ROUTE, "/").concat(data._id));
                }, data: suppliers, pagination: {
                    currentPage: pagination.page,
                    rowsPerPage: pagination.size,
                    totalRecords: pagination.countTotal,
                    onPageChange: function (page) {
                        getSuppliers({ page: page });
                    },
                    onRowsPerPageChange: function () { },
                }, colors: pages_1.tableColorConfig }))] })));
};
exports.SupplierTable = SupplierTable;
